<template>
  <div>
    <b-modal
      :title="$t('Personal Justifications')"
      size="lg"
      no-close-on-backdrop
      no-close-on-esc
      hide-footer
      scrollable
      v-model="show"
      @hidden="$emit('hidden')"
    >
      <b-row class="my-1 d-flex justify-content-between">
        <b-col xl="7" lg="7" md="9" sm="9">
          <b-form-group :label="$t('Employee')">
            <b-form-input
              v-model="personal.name"
              disabled
              style="max-width: 350px"
            />
          </b-form-group>
        </b-col>

        <b-col
          v-if="itemsSelected.length > 0"
          xl="4"
          lg="4"
          md="4"
          sm="4"
          class="text-right mt-20"
        >
          <b-button
            :variant="
              itemsSelected.length > 0 ? 'outline-primary' : 'outline-secondary'
            "
            @click="openMultipleJustificationAttendanceModal"
            v-b-tooltip.hover.bottom="$t('Multiple Justifications')"
            :disabled="itemsSelected.length == 0"
          >
            GENERAR JUSTIFICACIONES
          </b-button>
        </b-col>
      </b-row>

      <b-row class="mb-1">
        <b-col cols="12">
          <b-table
            striped
            selectable
            hover
            :items="inconsistences"
            :fields="fields"
            ref="incosistencesTable"
            class="position-relative font-small-3"
            table-class="text-nowrap"
            responsive="sm"
            small
            show-empty
          >
            <template #head(selected)="data">
              <b-form-checkbox
                @change="selectAll(data)"
                v-model="selectedAll"
              ></b-form-checkbox>
            </template>

            <template #cell(selected)="data">
              <b-form-checkbox
                @change="checked(data.index, data.item.rowSelected)"
                v-model="data.item.rowSelected"
              >
              </b-form-checkbox>
            </template>

            <template #cell(date)="data">
              {{ data.item.date }}
            </template>

            <template #cell(start)="data">
              <feather-icon
                v-if="data.item.is_late"
                icon="ClockIcon"
                class="mr-50 text-warning"
                size="16"
              />
              <b-badge
                :variant="
                  data.item.start != null ? 'light-success' : 'light-danger'
                "
              >
                {{ data.item.start != null ? data.item.start : $t("Not Mark") }}
              </b-badge>
            </template>

            <template #cell(end)="data">
              <b-badge
                :variant="
                  data.item.end != null ? 'light-success' : 'light-danger'
                "
              >
                {{ data.item.end != null ? data.item.end : $t("Not Mark") }}
              </b-badge>
            </template>

            <!-- <template #cell(status_name)="data">
              {{ $t(resolveNameStatus(data.item.new_status)) }}
            </template> -->

            <template #cell(new_status)="data">
              <b-badge :variant="resolveStyleAttendance(data.item.new_status)">
                {{ $t(resolveStatusName(data.item.new_status)) }}
              </b-badge>
            </template>

            <template #cell(justification_count)="data">
              <b-badge
                v-if="data.item.justification_count > 0"
                variant="light-primary"
                class="mr-1"
              >
                {{ data.item.justification_count }}
              </b-badge>

              <span v-else class="text-muted">
                {{ $t("No justifications") }}
              </span>
            </template>

            <template #row-details="row">
              <b-row class="my-2 text-center">
                <b-col cols="12">
                  <strong>
                    {{ $t("Justifications") }}
                  </strong>
                </b-col>
              </b-row>

              <b-card
                v-for="(justification, index) in row.item.justifications"
                :key="index"
              >
                <b-row class="d-flex justify-content-between" no-gutters>
                  <b-col cols="6" class="text-left">
                    <span class="fs-5">
                      {{ $t("Motive: ") }}
                      {{ $t(justification.justification_name) }}
                    </span>
                    <br />
                    <span class="fs-5">
                      {{ $t("Observation: ") }}
                    </span>
                    {{ justification.observation }}
                    <br />
                    <b-row>
                      <b-col cols="2">
                        <span class="fs-5" v-if="justification.filename">
                          {{ $t("File:") }}
                        </span>
                      </b-col>
                      <b-col cols="6">
                        <FileBadge
                          v-if="justification.filename"
                          :file="{
                            name: justification.filename,
                            extension: justification.file_ext,
                            size: justification.file_size,
                            url: justification.url_file,
                          }"
                          downloadable
                        />
                      </b-col>
                    </b-row>
                    <span class="mt-1">
                      {{ $t("Created at") }}
                      {{ justification.justification_created_at | prettyDate }}
                      <br />
                      {{ $t("by") }}
                      {{ justification.justification_created_by | capitalize }}
                    </span>
                  </b-col>
                  <b-col cols="6" class="text-right">
                    <b-badge
                      :variant="getVariant(justification.justification_status)"
                      class="fs-5"
                    >
                      {{ $t(justification.justification_status) }}
                    </b-badge>
                  </b-col>
                </b-row>
              </b-card>
            </template>

            <template #cell(actions)="row">
              <feather-icon
                v-if="row.item.justification_count == 0"
                icon="EditIcon"
                class="text-primary cursor-pointer mr-50"
                size="16"
                @click="openModalJustificationAttendance(row.item, 'single')"
              />

              <feather-icon
                v-if="row.item.justification_count == 0"
                icon="CheckIcon"
                v-b-tooltip.hover.bottom="$t('Create Manual Attendance')"
                class="text-success cursor-pointer mr-50"
                size="16"
                @click="openCreateManualAttendanceModal(row.item)"
              />

              <feather-icon
                v-if="row.item.justification_count > 0"
                :icon="
                  row.item._showDetails > 0
                    ? 'ChevronUpIcon'
                    : 'ChevronDownIcon'
                "
                size="17"
                :class="
                  row.item._showDetails > 0 ? 'text-danger' : 'text-success'
                "
                @click="row.toggleDetails"
              />
            </template>
          </b-table>
        </b-col>
      </b-row>
    </b-modal>

    <ModalJustificationAttendance
      v-if="showModalJustificationAttendance"
      :personal="justifyData"
      :datesSelected="itemsSelected"
      :mode="mode"
      @hidden="showModalJustificationAttendance = false"
      @stored="storedEvent"
    />

    <ModalCreateManualAttendance
      v-if="showCreateManualAttendanceModal"
      :attendanceData="attendance"
      @hidden="showCreateManualAttendanceModal = false"
      @stored="storedEvent"
    />
  </div>
</template>
<script>
import ModalJustificationAttendance from "@/views/commons/employee_attendance/justifications/modals/ModalJustificationAttendance.vue";
import AttendanceService from "@/views/rrhh/views/attendance/services/attendance.service.js";
import FileBadge from "@/views/commons/utilities/FileBadge.vue";
import ModalCreateManualAttendance from "@/views/commons/employee_attendance/justifications/modals/ModalCreateManualAttendance.vue";

export default {
  components: {
    ModalJustificationAttendance,
    FileBadge,
    ModalCreateManualAttendance,
  },
  props: {
    personal: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      selectedAll: false,
      mode: "",
      info: {},
      fields: [
        {
          key: "selected",
          label: "",
          sortable: false,
          visible: true,
        },
        { key: "date", label: this.$t("Date") },
        { key: "start", label: this.$t("Checking") },
        { key: "end", label: this.$t("Check out") },
        { key: "new_status", label: this.$t("Status") },
        {
          key: "justification_count",
          label: this.$t("Total Justifications"),
          tdClass: "text-center",
          thClass: "text-center",
        },
        { key: "actions", label: this.$t("Actions"), tdClass: "text-center" },
      ],
      inconsistences: [],
      show: true,
      itemsSelected: [],
      tableData: [],
      showModalJustificationAttendance: false,
      justifyData: {},
      showCreateManualAttendanceModal: false,
      attendance: {},
    };
  },
  mounted() {
    this.getEmployeeJustification();
  },
  methods: {
    openCreateManualAttendanceModal(row) {
      this.showCreateManualAttendanceModal = true;
      this.attendance.date = row.date;
      this.attendance.personal_id = this.personal.personal_id;
      this.attendance.start = row.start;
    },

    openMultipleJustificationAttendanceModal() {
      this.justifyData = {
        personal_id: this.personal.personal_id,
      };
      this.mode = "multiple";
      this.showModalJustificationAttendance = true;
    },
    selectAll(data) {
      let tableRef = this.$refs["incosistencesTable"];
      if (this.selectedAll === true) {
        this.tableData.forEach((element, index) => {
          tableRef.selectRow(index);
          this.tableData[index].rowSelected = true;
          this.itemsSelected.push(element.date);
        });
      } else {
        this.tableData.forEach((element, index) => {
          tableRef.unselectRow(index);
          this.tableData[index].rowSelected = false;
        });
        this.itemsSelected = [];
      }
    },
    checked(index, checked) {
      let tableRef = this.$refs["incosistencesTable"];

      if (checked == false) {
        tableRef.unselectRow(index);
        this.tableData[index].rowSelected = false;
        this.itemsSelected = this.itemsSelected.filter(
          (item) => item != this.tableData[index].date
        );
      } else {
        tableRef.selectRow(index);
        this.tableData[index].rowSelected = true;
        this.itemsSelected.push(this.tableData[index].date);
      }
    },
    openModalJustificationAttendance(item, mode) {
      this.justifyData = {
        personal_id: this.personal.personal_id,
        start_date: item.date,
      };
      this.mode = mode;
      this.showModalJustificationAttendance = true;
    },
    getVariant(status) {
      if (status == "Pending") {
        return "light-warning";
      } else if (status == "Approved By HR" || status == "Approved By Chief") {
        return "light-primary";
      } else if (status == "Rejected By HR" || status == "Rejected By Chief") {
        return "light-danger";
      }
    },
    storedEvent() {
      this.showModalJustificationAttendance = false;
      this.selectedAll = false;
      this.itemsSelected = [];
      this.getEmployeeJustification();
      this.showCreateManualAttendanceModal = false;
      this.$emit("stored");
    },
    async getEmployeeJustification() {
      try {
        const { data } = await AttendanceService.getEmployeeJustification(
          this.personal
        );
        this.inconsistences = data[0].attendances;
        this.tableData = data[0].attendances;
      } catch (error) {
        console.log(error);
      }
    },
    resolveNameStatus(status) {
      let name = "Not mark";
      switch (status) {
        case 4:
          name = "Without schedule";
          break;
        case 5:
          name = "Not Mark";
          break;
        case 6:
          name = "Justified";
          break;
        case 7:
          name = "Justify rejected";
          break;
        case 8:
          name = "Not Justified";
          break;
        default:
          break;
      }
      return name;
    },

    resolveStatusName(status) {
      let name = "";
      switch (status) {
        case 1:
          name = "Working day";
          break;
        case 2:
          name = "No working day";
          break;
        case 3:
          name = "Working remote";
          break;
        case 4:
          name = "Not Schedule";
          break;
        case 5:
          name = "Not Mark";
          break;
        case 6:
          name = "Justified";
          break;
        case 7:
          name = "Justify rejected";
          break;
        case 8:
          name = "Not Justified";
          break;
        default:
          break;
      }
      return name;
    },

    resolveStyleAttendance(status) {
      let style = "";
      switch (status) {
        case 1:
          style = "light-success";
          break;
        case 2:
          style = "light-warning";
          break;
        case 3:
          style = "light-primary";
          break;
        case 4:
          style = "light-warning";
          break;
        case 5:
          style = "light-danger";
          break;
        case 6:
          style = "light-primary";
          break;
        case 7:
          style = "light-danger";
          break;
        case 8:
          style = "light-warning";
          break;
        default:
          break;
      }
      return style;
    },
  },
};
</script>
<style >
.fs-5 {
  font-size: 0.9rem !important;
  text-transform: uppercase;
  font-weight: 700 !important;
}

.dark-layout .table.b-table > tbody .b-table-row-selected.table-active td {
  background-color: #424141 !important;
}

.mt-20 {
  margin-top: 2rem !important;
}
</style>
```